// Types
export type LanguageT = 'es' | 'en';
export type LanguageItem = { code: LanguageT; label: string; short: string };
export type ThemeT = 'light' | 'dark';

// Constants
export enum Language {
  ES = 'es',
  EN = 'en',
}

export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
}

export const languages: LanguageItem[] = [
  { code: Language.ES, label: 'Spanish', short: 'ES' },
  { code: Language.EN, label: 'English', short: 'EN' },
];
